
define('ldsh!modules/domain_listing/templates/main', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-dom-actions">\n  <a\n    href="/domains/new"\n    class="ed-btn ed-btn-sec js-add-domain"\n    data-bypass\n    data-galabel=""\n    data-gaaction=""\n    data-gacategory=""\n    data-gaevent=""\n    data-i18n="domainListing.add"\n  ></a>\n</div>\n<div class="js-list-container"></div>\n<p class="ed-help-txt">' +
((__t = ( cnameHelp )) == null ? '' : __t) +
'</p>\n';

}
return __p
};});

